var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center py-3 no-data-style"},[_vm._m(0),_vm._v(" "+_vm._s(_vm.processingMessage)+" ")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center pb-2"},[_c('div',{staticClass:"in-process-spinner"})])
}]

export { render, staticRenderFns }